<template>
  <v-row no-gutters v-if="this.prices != null">
    <v-col cols="6" class="pe-grey lighten" :class="$vuetify.breakpoint.xsOnly ? 'pa-3' : 'pa-5'">
      <h4>Öljylämmitys</h4>
      <div class="result-text">
        {{ price('oljy') }} {{ this.unit }}
        <br />
        <span class="dark" :class="isDistrictHeatBetter('oljy') ? 'pe-green--text' : ''">
          {{ difference('oljy') }} {{ this.unit }}
        </span>
      </div>
    </v-col>
    <v-col cols="6" order="1" class="pe-grey" :class="$vuetify.breakpoint.xsOnly ? 'pa-3' : 'pa-5'">
      <h4>Maalämpö</h4>
      <div class="result-text">
        {{ price('maalampo') }} {{ this.unit }}
        <br />
        <span class="dark" :class="isDistrictHeatBetter('maalampo') ? 'pe-green--text' : ''">
          {{ difference('maalampo') }} {{ this.unit }}
        </span>
      </div>
    </v-col>
    <v-col cols="6" order="1" class="pe-grey" :class="$vuetify.breakpoint.xsOnly ? 'pa-3' : 'pa-5'">
      <h4>Sähkölämmitys</h4>
      <div class="result-text">
        {{ price('sahko') }} {{ this.unit }}
        <br />
        <span class="dark" :class="isDistrictHeatBetter('sahko') ? 'pe-green--text' : ''">
          {{ difference('sahko') }} {{ this.unit }}
        </span>
      </div>
    </v-col>
    <v-col cols="6" order="1" class="pe-grey lighten" :class="$vuetify.breakpoint.xsOnly ? 'pa-3' : 'pa-5'">
      <h4>Ilmavesilämpöpumppu</h4>
      <div class="result-text">
        {{ price('ilmavesi') }} {{ this.unit }}
        <br />
        <span class="dark" :class="isDistrictHeatBetter('ilmavesi') ? 'pe-green--text' : ''">
          {{ difference('ilmavesi') }}  {{ this.unit }}
        </span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  import { subtract, round } from 'mathjs';
  export default {
    name: "CompareDetailFields",
    props: {
      prices: {
        type: Object,
        default: null,
      },
      field: {
        type: String,
      },
      unit: {
        type: String,
      }
    },
    methods: {
      price(t) {
        if (this.prices == null) {
          return 0;
        }
        return round(this.prices[t][this.field]).toLocaleString('fi');
      },
      isDistrictHeatBetter(t) {
        if (this.prices == null) {
          return 0;
        }
        return round(subtract(this.prices.kaukolampo[this.field], this.prices[t][this.field])) < 0;
      },
      difference(t) {
        if (this.prices == null) {
          return 0;
        }
        return round(subtract(this.prices.kaukolampo[this.field], this.prices[t][this.field])).toLocaleString('fi');
      },
    },
  }
</script>

<style lang="scss" scoped>
  .result-text {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    margin-top: 5px;

    .dark {
      color: rgba(0,0,0,0.45);
      font-size: 14px;
      line-height: 16px;

      &.pe-green--text {
        color: #50BE00;
      }
    }

    &.big-text {
      font-size: 31px;
    }
  }

  @media only screen and (min-width: 600px) {
    .result-text {
      font-size: 28px;

      .dark {
        font-size: 22px;
        line-height: 22px;
      }

      &.big-text {
        font-size: 42px;
      }
    }
  }
</style>
